const storage = {
  setLocal: function(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  getLocal: function(key) {
    let value = localStorage.getItem(key);
    return JSON.parse(value);
  },
  setSession: function(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  getSession: function(key) {
    let value = sessionStorage.getItem(key);
    return JSON.parse(value);
  },
  clearOneLocal: function(key) {
    localStorage.removeItem(key);
  },
  clearOneSession: function(key) {
    sessionStorage.removeItem(key);
  },
  clearAllLocal: function() {
    localStorage.clear();
  },
  clearAllSession: function() {
    sessionStorage.clear();
  }
};
export { storage };
